import { render, staticRenderFns } from "./IETips.vue?vue&type=template&id=64f24179&scoped=true"
import script from "./IETips.vue?vue&type=script&lang=js"
export * from "./IETips.vue?vue&type=script&lang=js"
import style0 from "./IETips.vue?vue&type=style&index=0&id=64f24179&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f24179",
  null
  
)

export default component.exports